import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('token') || null,
  userId: localStorage.getItem('userId') || null,
  username: localStorage.getItem('username') || null,
  isAdmin: localStorage.getItem('isAdmin') === 'true' || false,
  role: localStorage.getItem('role') || null,

  setAuth: (token, userId, username, isAdmin, role = null) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('username', username);
    localStorage.setItem('isAdmin', isAdmin);
    if (role) localStorage.setItem('role', role);
    set({ token, userId, username, isAdmin, role });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('role');
    set({ token: null, userId: null, username: null, isAdmin: false, role: null });
  },
}));

export const useInvestigationStore = create((set, get) => ({
  investigations: [],
  currentInvestigation: null,
  graphData: null,
  loading: false,
  error: null,

  setInvestigations: (investigations) => set({ investigations }),
  setCurrentInvestigation: (investigation) => set({ currentInvestigation: investigation }),
  setGraphData: (graphData) => set({ graphData }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  addInvestigation: (investigation) =>
    set((state) => ({ investigations: [investigation, ...state.investigations] })),
}));
